import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const painPoints = ['No tengo tiempo, mis hijos me consumen el día.', 'No soy experta en nada, ¿qué podría enseñar?', 'No sé usar programas de diseño complicados.', 'Me da pena vender o mostrar mi cara en redes.', 'Siento que ya hay mucha competencia.'];
export function PainReality() {
  return <section className="py-16 px-4 bg-gray-50" data-id="element-143">
      <div className="max-w-4xl mx-auto" data-id="element-144">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-serif text-3xl md:text-4xl text-dark text-center mb-12" data-id="element-145">
          Si has pensado "yo no nací para vender"... no es verdad. Solo te falta
          el mapa.
        </motion.h2>

        <div className="space-y-4 mb-12" data-id="element-146">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-white p-6 rounded-lg shadow-sm" data-id="element-147">
              <XCircle className="w-6 h-6 text-primary flex-shrink-0 mt-1" data-id="element-148" />
              <p className="text-body text-lg" data-id="element-149">{point}</p>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-xl md:text-2xl text-dark text-center font-semibold" data-id="element-150">
          No necesitas más tiempo ni talento. Necesitas un sistema que haga el
          trabajo pesado por ti.
        </motion.p>
      </div>
    </section>;
}